export default async (context) => {
    if(context.temporaryData.control === 'ending') {
        await context.$store.dispatch('ending_video/clearAll')
        await context.video_editor_set_videos(context)
    } else {
        await context.$store.dispatch('main_videos/deleteVideo', {
            index: context.temporaryData.index - 1
        })
    }

    context.close_popup(context)
    context.temporaryData = false
    context.editElementStatus = false
}